export function getAnalyticsQueryParams(search: string = '') {
  if (!search) return;

  const searchParams = new URLSearchParams(search);
  const query = Object.fromEntries(searchParams);

  const {
    ens_consent,
    rsid,
    vid,
    s_appdroid,
    s_appios,
    adobe_mc,
    jl_uuid,
    firebase_instance_id,
    firebase_session_id,
    citrus_id,
    monetateId,
    cheq_uuid,
    irclickid,
    gclid,
    msclkid,
  } = query ?? {};

  const entries = Object.entries({
    ens_consent,
    rsid,
    vid,
    s_appdroid,
    s_appios,
    adobe_mc,
    jl_uuid,
    firebase_instance_id,
    firebase_session_id,
    citrus_id,
    monetateId,
    cheq_uuid,
    irclickid,
    gclid,
    msclkid,
  }).filter(([_, value]) => value !== undefined);

  return entries.length > 0 ? Object.fromEntries(entries) : undefined;
}
